<template>
<Layout class="landing-page">
  <Navbar/>
  <div class="container">
    <Row>
      <Col :md="{span:14}" :sm="{span:24}" :xs="{span:24}">
        <div v-if="isLandingContentExists" v-html="landingContent.html"></div>
      </Col>
      <Col :md="{span:9, offset:1}" :sm="{span:24}" :xs="{span:24}" class="register-area">
        <Button class="big-btn" type="primary" long @click="register">
          <span v-if="isRegRequired">{{ $t("register") }}</span>
          <span v-if="!isRegRequired">{{ $t("join_now") }}</span>
        </Button>
      </Col>
    </Row>
  </div>
</Layout>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

export default {
  name: 'landing',
  data() {
    return {
      webcastId: this.$store.state.webcast.copy._id,
      isReady: false
    }
  },

  computed: {
   
    ...mapGetters('page-settings', {
      getPageSettings: 'find'
    }),

    ...mapGetters('landing-content', {
      getLandingContentFromStore: 'find'
    }),

    landingContent () {
      return this.getLandingContentFromStore({query: {webcastId: this.webcastId}}).data[0]
    },

    isLandingContentExists () {
      return Boolean(this.landingContent && this.landingContent.html)
    },

    isRegRequired(){
      if(this.$store.state['page-settings'].copy.registrationEnabled && !this.registration()){
        return true;
      }
    }
  },

  methods: {
    ...mapActions('landing-content', {
      fetchLandingContentAction: 'find'
    }),
     ...mapGetters('registrations', {
      registration: 'getCopy'
    }),

    register () {
      //console.log(this.isRegRequired);
      if(!this.isRegRequired){
        if(this.$store.state.stream.ids.length > 1){
          this.$router.push('stream-select');
        } else {
          this.$router.push('live');
        }
      } else {
        this.$router.push('register');
      }
    }
  },

  created () {
    this.fetchLandingContentAction({query: {webcastId: this.webcastId}})
  },

  components: {
    Navbar
  }
}
</script>

<style lang="scss">
  .landing-page {
    img {
      max-width: 100%;
    }
  }
</style>

<style lang="scss" scoped>

.register {
  &-area {
    padding:40px;
    background-color: #f7f7f7;
  }
}
</style>
